// hooks/useEventDetails.js
import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const getEventDetails = async (eventId, getAccessTokenSilently) => {
  const token = await getAccessTokenSilently();
  const apiUrl = process.env.REACT_APP_API_URL;

  const { data } = await axios.get(
    `${apiUrl}/api/events/event-details/${eventId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};

export const useEventDetails = (eventId) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery(
    ["eventDetails", eventId],
    () => getEventDetails(eventId, getAccessTokenSilently),
    {
      enabled: !!eventId, // The query will not execute until the eventId exists
    }
  );
};
